import styled from 'styled-components';
import Modal from './Modal';
import { useState } from 'react';
import CloseBg from "../assets/images/bg_close.svg";



const StyledFooter = styled.footer`
    width: 100%;
    background-color: #545454;
    padding: 5rem 3.25rem;
    box-sizing: border-box;
`

const FooterTitle = styled.div`
    color: white;
    font-family: 'Esamanru', sans-serif;
    font-size: 1.75rem;
    letter-spacing: -0.08rem;
`

const FooterDescription = styled.div`
    font-family: 'Pretendard Variable';
    font-size: 1rem;
    font-weight: 300;
    color: white;
    padding: 0.25rem 0;
`

const ModalContainer = styled.div`
    background-color: white;
    width: 70.5rem;
    height: 46.25rem;
    align-items: center;
    justify-content: center;
`

const ModalHeader = styled.div`
    position: relative;
    height: 5.75rem;
    justify-content: center;
    align-items: center;
    display: flex;
    font-family: 'Esamanru', sans-serif;
    font-size: 1.5rem;
    font-weight: 200;
    color: #545454;
    border-bottom: 0.125rem solid #545454;
`

const CloseButton = styled.img`
    position: absolute;
    right: 1.625rem;
    width: 2.5rem;
    height: 2.5rem;
    cursor: pointer;
`

const DonationFooterDescription = styled(FooterDescription)`
    cursor: pointer;
    margin-top: 1rem;
    text-decoration: underline;
`

const DonationDescription = styled.div`
    font-family: 'Pretendard Variable';
    font-size: 1.225rem;
    font-weight: 300;
    white-space: pre-line;
    padding: 3rem 4rem;
`

const CopyableDescription = styled.div`
    font-family: 'Pretendard Variable';
    font-size: 1.5125rem;
    font-weight: 300;
    border-radius: 0.375rem;
    cursor: pointer;
    padding: 2rem 4rem;
    text-decoration: underline;
`

export default function Footer() {

    const [isDonationModalOpen, setDonationModalOpen] = useState(false);
    const donationBank = "토스뱅크"
    const bankNumber = "1001-3804-4563"

    const onCopyClicked = () => {
        navigator.clipboard.writeText(bankNumber);
        alert("후원계좌가 복사되었습니다.");
    }

    return (
        <StyledFooter>
            <FooterTitle>
                프로야구 스쿼드 메이커
            </FooterTitle>

            <div style={{height: '1.25rem'}}></div>

            <FooterDescription>
                nakim3159@gmail.com / PARAOOO
            </FooterDescription>
            <FooterDescription>
                제작자의 허용없이 데이터 무단 사용, 웹페이지 무단 복제 금지
            </FooterDescription>

            <DonationFooterDescription onClick={() => {setDonationModalOpen(true)}}>
                개발자에게 후원하기
            </DonationFooterDescription>

            <Modal isOpen={isDonationModalOpen} onClose={() => {setDonationModalOpen(false)}}>
                <ModalContainer>
                    <ModalHeader>
                        개발자에게 후원하기
                        <CloseButton
                            src={CloseBg}
                            onClick={() => {setDonationModalOpen(false)}}
                        />
                    </ModalHeader>

                    <DonationDescription>
                        안녕하세요, "프로야구 스쿼드 메이커" 개발자 PARAOOO입니다.<br/><br/>

                        후원자님의 소중한 후원은 저희가 프로그램을 유지하고, 다음 단계로 발전시키는 데 있어 가장 큰 격려가 됩니다.<br/><br/>

                        [후원금 사용 계획 예시]:<br/><br/>

                            - 서버 유지 보수 및 안정화<br/><br/>

                            - 새로운 기능 개발<br/><br/>

                            - 데이터 업데이트 및 확장<br/><br/>

                            - 개발자의 소소한 행복 추구(붕어빵, 아메리카노, 뿌링클에 치즈볼 추가 등...)<br/><br/>

                        여러분의 후원이 더 나은 유저 경험으로 돌아올 것을 약속드립니다.<br/>
                        금액과 관계없이 모든 응원 진심으로 감사드립니다.<br/>
                    </DonationDescription>

                    <CopyableDescription onClick={onCopyClicked}>
                        후원계좌 : {donationBank} {bankNumber}
                    </CopyableDescription>

                </ModalContainer>
            </Modal>
            
        </StyledFooter>
    );
}